// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"be4b98fb","129":"0f639c1e","197":"7d950c80","618":"46c5e989","992":"6b0a94cf"}[chunkId] + ".chunk.js";
};